import PropTypes from "prop-types"
import { Fragment } from "react"
import { get, map } from "lodash"
import { List, ListItemButton, ListItemText } from "@mui/material"
import MetricType from "./metric-type"
import { MetricItemShape } from "./helpers/prop-types"
import ExpandIcon from "./expand-icon"
import CheckboxElement from "./checkbox"

export default function Metric({
  item,
  toggleSection,
  toggleSelectedMetricColumn,
  disableOptions,
  includeMetricTypes,
  getIsSectionOpen,
  getIsSelected,
}) {
  const items = get(item, "items", [])
  const useMetricTypes = includeMetricTypes && items.length > 1
  const onlyDefaultMetricType = includeMetricTypes && items.length === 1
  const selector = onlyDefaultMetricType ? items[0].selector : item.selector
  const isSelected = getIsSelected(selector)
  const isDisabled = !isSelected && !useMetricTypes && disableOptions
  const isSectionOpen = getIsSectionOpen(item.selector)

  const handleClick = () => (useMetricTypes ? toggleSection : toggleSelectedMetricColumn)(selector)

  return <Fragment>
    <ListItemButton
      disabled={isDisabled}
      classes={{ root: "list-item" }}
      className="metrics-item"
      key={item.id}
      onClick={handleClick}
    >
      <CheckboxElement
        isHidden={useMetricTypes}
        isChecked={isSelected}
        isDisabled={isDisabled}
        className="metrics-checkbox"
      />
      <ListItemText>{item.label || item.id}</ListItemText>
      <ExpandIcon
        isOpen={isSectionOpen}
        isHidden={!useMetricTypes}
      />
    </ListItemButton>
    {useMetricTypes && isSectionOpen && <List className="searchable-list" disablePadding>
      {map(items, option => <MetricType
        key={`${item.id}.${option.id}`}
        option={option}
        toggleSelectedMetricColumn={toggleSelectedMetricColumn}
        disableOptions={disableOptions}
        getIsSelected={getIsSelected}
      />)}
    </List>}
  </Fragment>
}

Metric.propTypes = {
  subcategoryType: PropTypes.string.isRequired,
  item: MetricItemShape.isRequired,
  toggleSection: PropTypes.func.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  includeMetricTypes: PropTypes.bool,
  getIsSectionOpen: PropTypes.func.isRequired,
  getIsSelected: PropTypes.func.isRequired,
}
